export { StoreHoursInfo } from './StoreHoursInfo';
